// extracted by mini-css-extract-plugin
export default {"folderstructureblog":"folderstructureblog_beb83bdfa4c0a878a646","requiredentries":"requiredentries_d3cd2ef6eef740a33824"};